import Vue from 'vue'

export default async (recaptchaToken) => {
  const res = await Vue.axios.post('/auth/otp_sms', {
    recaptchaToken: recaptchaToken
  })
  return res.data
}



// WEBPACK FOOTER //
// ./src/services/auth/resend-sms-otp.js